import _ from 'lodash';

export default {
  props: {
    editing: Object,
  },
  data() {
    return {
      isLoading: false,
      drawerOpen: false,
      model: {},
      defaultModel: {},
    };
  },
  watch: {
    editing(newValue) {
      this.restoreModelPre(newValue);
    },
  },
  created() {
    this.defaultModel = _.cloneDeep(this.model);
  },
  mounted() {
    this.restoreModelPre(this.editing);
  },
  methods: {
    resetModel() {
      this.model = _.cloneDeep(this.defaultModel);
    },
    createNew() {
      this.resetModel();
      this.openDrawer();
      this.postCreateNew();
    },
    postCreateNew() {},
    openDrawer() {
      this.drawerOpen = true;
    },
    closeDrawer() {
      this.drawerOpen = false;
      this.$emit('close');
    },
    restoreModel() { },
    // Have this as a separate method so it does not get overridden
    restoreModelPre(newValue) {
      if (newValue) {
        this.restoreModel(newValue);
        this.drawerOpen = true;
      }
    },
  },
};
